import BaseComponent from '@/js/core/BaseComponent'
import Events from '@/js/core/EventDispatcher'
import $ from 'jquery'

export default class Gallery extends BaseComponent {
  static GALLERY_OPEN = 'gallery--open'
  static GALLERY_DISMISS = 'gallery--dismiss'

  static root = '[data-gallery]'


  state = {
    model: false,
    template: '',
    imgIndex: 0
  }

  actions = {
    model: 'update'
  }
  
  getModel (data) {
    const model = {}
    for (const key in data) {
      const value = data[key]
      model[`{${key}}`] = value
    }

    return model
  }

  update () {
    const { model, template } = this.state
    if (model) {
      this.$.overlay && this.$.overlay.remove()
      this.$.overlay = $(
        template.replace(
          /{imagePoster}|{imagePosterRatio}|{imageTitle}|{imageDescription}|{productHead}|{productThumb}|{productLink}|{productName}|{productCat}/gi
          , matched => model[matched]))
      this.$.overlay.find('[data-image-ratio]').ratio()
      this.$.el.append(this.$.overlay)
      setTimeout(() => this.$.body.addClass(Gallery.GALLERY_OPEN), 1000/60)
      setTimeout(() => Events.emit('layout:update'), 1000/60)
    } else {
      this.$.body && this.$.body.removeClass(Gallery.GALLERY_OPEN).addClass(Gallery.GALLERY_DISMISS)
      setTimeout(() => this.$.body && this.$.body.removeClass(Gallery.GALLERY_DISMISS), 800)
    }
  }

  addListeners () {
    this.$.body
        .on('click', '[data-gallery-thumb]', (event) => {
          const $thumb = $(event.currentTarget).find('img')
          const model = this.getModel($thumb.data())
          this.setState(() => ({ model }))

          const nuIndex = $thumb.data()
          this.setState(() => ({ imgIndex: nuIndex.imgindex}))
          console.log('imgIndex:', nuIndex.imgindex)
          console.log('state index:', this.state.imgIndex)

          event.preventDefault() 
        })
        .on('click', '[data-close-overlay]', () => {
          this.setState(() => ({ 
            model: false 
          }))
        })
        .on('keydown', (e) => {

          e = e || window.event;
      
          if (e.keyCode == '38' && $('body').hasClass('single-_cty_product')) {
              // up arrow
          }
          else if (e.keyCode == '40' && $('body').hasClass('single-_cty_product')) {
              // down arrow
          }
          else if (e.keyCode == '37' && $('body').hasClass('single-_cty_product')) {
            // left arrow
            const maxIndex = $('img[data-imgindex]').length
            this.setState(() => ({imgIndex: (this.state.imgIndex - 1) >= 0 ? (this.state.imgIndex - 1) : (maxIndex - 1)}))
            const $thumb = $(`img[data-imgIndex="${this.state.imgIndex}"]`)
            const model = this.getModel($thumb.data())
            this.setState(() => ({ model }))
          }
          else if (e.keyCode == '39' && $('body').hasClass('single-_cty_product')) {
            const maxIndex = $('img[data-imgindex]').length
            this.setState(() => ({imgIndex: (this.state.imgIndex + 1) < maxIndex ? (this.state.imgIndex + 1) : 0}))

            const $thumb = $(`img[data-imgIndex="${this.state.imgIndex}"]`)
            const model = this.getModel($thumb.data())
            this.setState(() => ({ model }))
            
            
          }
      
      })
        
  }

  storeTemplate () {
    const template = $('#gallery-overlay-template').text()
    this.setState(() => ({ template }))  
  }
  
  mounted () {
    super.mounted()
    this.storeTemplate()
    this.addListeners()
  }
}
